import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { getDefaultDashboardRoute } from "../../utils/dashboardNavigation";

const DashboardRedirect = () => {
  const { permissions } = useAuth();
  const target = getDefaultDashboardRoute(permissions);
  const relativePath = target.replace(/^\/dashboard\/?/, "");

  return <Navigate to={relativePath || "unauthorized"} replace />;
};

export default DashboardRedirect;
